import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactSection from './components/ContactSection';

const ContactPage = () => {
  return (
    <div className="app">
      <Header />
      <div className="contact-page">
        <div className="portfolio-hero">
          <div className="container">
            <div className="portfolio-hero-content">
              <div className="portfolio-badge">
                <span>📬</span>
                <span>Contact</span>
              </div>
              <h1>Get In Touch</h1>
              <p>Ready to start your next project? Let's create something amazing together.</p>
            </div>
          </div>
        </div>
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;